import { render, staticRenderFns } from "./languageSelector.vue?vue&type=template&id=6316904c&scoped=true&"
import script from "./languageSelector.vue?vue&type=script&lang=js&"
export * from "./languageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316904c",
  null
  
)

export default component.exports